import { useEffect, useState } from "react";
import "../css/search.css";
import { Link, useSearchParams } from "react-router-dom";
import MerlinDB from "@chrisaxxwell/merlin-db";
import { SearchContainer } from "./header";
import { defineStyle } from "./reference";
import axios from "axios";
import Head from "./head";
var merlin = MerlinDB();
merlin.connect("merlinDB");

var schemaSearch = merlin.Schema({
   name: String,
   content: Object
});

var model = merlin.model("guides-content", schemaSearch);
var timer = null;

function Searching(params, event) {
   clearTimeout(timer);
   timer = setTimeout(() => {
      var setQuery = params.setSearch;

      setQuery(`?query=${event.target.value}`);

   }, 100);
}

function getDataGuides() {

   return new Promise((resolve, reject) => {

      merlin.getModel("guides-content").then(resolve).catch(async e => {
         var { data } = await axios.get("/json/guides-content-en.json");

         model.insert(data).then(resolve).catch(e => { })
      })
   });
}

export default function Search() {
   var [ param, setParam ] = useSearchParams();
   var [ search, setSearch ] = useState([]);
   var query = param.get("query");
   var url = window.location.origin;
   useEffect(() => {

      getDataGuides().then(e => {
         model.find({
            'content.h1': { $regex: [ `${query || ""}`, 'gi' ] }
         }).limit(20).map(e => {
            return {
               url: url + '/manual/reference/' + e.name,
               title: e.content.h1,
               subtitle: e.content.h2,
               description: e.content.h3,
            }
         }).sort((a, b) => {

            return a.name.length - b.name.length;
         }).then(e => {
            setSearch(e);
         });
      })
   }, [ query, url ]);

   return (
      <main id="search-session">
         <Head props={{
            site_name: "MerlinDB",
            page_type: "website",
            title: "Search Page - MerlinDB",
            description: "Find fast and accurate results on our search platform. Explore a variety of categories and themes to discover relevant and useful information.",
            page_author: "Chris Axxwell",
            index: "noindex, nofollow, noarchive",
            keywords: "Database, database, MerlinDB, IndexedDB, Banco de dados",
            canonical: "/search",
            lang: "en_US",
            theme_color: "#250649",
            img_page: "/merlindb-poster.jpg", //imagem que ta dentro de src/files/images/head/
            img_alt: "MerlinDB poster",
            twitter_username_creator: "chrisaxxwell",
            twitter_username: "chrisaxxwell",
            icon: "/merlin-logo.svg", //o icone da pagina em /src/files/
            noCache: false, //adicone true, em paginas de usuario e paginas que nao quer adiionar no cache, se for true entao noa adicionapaginas no cache tipo para paginas de usuario, paginas de blogs atualizados e tals
            //redirect: ["https://www.chrisaxxwell.com", 3], //redireciona a pagina para outra pagina ou outro dominio depois de 3 segundos ou nao defina para 0
         }} />
         <div>
            <SearchContainer setSearch={setParam} />
         </div>
         <div id="search-content">
            {
               search.length !== 0 ? (
                  search.map((e, i) => (
                     <div key={i}>
                        <Link to={e.url} />
                        <h3 dangerouslySetInnerHTML={{ __html: defineStyle(e.title) }} />
                        <h4 dangerouslySetInnerHTML={{ __html: defineStyle(e.subtitle) }} />
                        <h5 dangerouslySetInnerHTML={{ __html: defineStyle(e.description) }} />
                        <Link to={e.url}>{e.url}</Link>
                     </div>
                  ))
               ) : (
                  <h5>0 documents founded!</h5>
               )
            }
         </div>
      </main>
   )
}

export { Searching };
